

import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';

import 'iview/dist/styles/iview.css';



Vue.use(iView);

Vue.config.productionTip = false

const VideoZwImg = require('./assets/imgs/cjgcj/sdsd1_01.png');

import VueLazyload from 'vue-lazyload'


import echarts from 'echarts'

Vue.prototype.$echarts = echarts


Vue.use(VueLazyload, {
loading: VideoZwImg,
adapter: {
loaded({
bindType,
el,
naturalHeight,
naturalWidth,
$parent,
src,
loading,
error,
Init
}) {


el.nextElementSibling.style.display = 'flex';
}
}
})


import VueScroller from 'vue-scroller'
Vue.use(VueScroller)



import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin, {
position: 'middle',
type: 'text'
})



import VueResource from 'vue-resource'
Vue.use(VueResource)

Vue.prototype.isDate = () => {
var date = '2018/11/19 13:00:00';
var dateTime = new Date(date).getTime();
var nowDate = new Date().getTime()
if (dateTime >= nowDate) {
return false
} else {
return true
}
}




Date.prototype.Format = function (fmt) { //author: meizz
var o = {
"M+": this.getMonth() + 1, //月份
"d+": this.getDate(), //日
"h+": this.getHours(), //小时
"m+": this.getMinutes(), //分
"s+": this.getSeconds(), //秒
"q+": Math.floor((this.getMonth() + 3) / 3), //季度
"S": this.getMilliseconds() //毫秒
};
if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
for (var k in o)
if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
return fmt;
}




router.beforeEach((to, from, next) => {
Vue.$vux.loading.hide();

if (to.matched[0]){
to = to.matched[0]
}
to.meta.title ? document.querySelector('title').textContent = to.meta.title : null;
to.meta.description ? document.querySelector('meta[name="Description"]').setAttribute('content', to.meta.description) : null;
to.meta.keywords ? document.querySelector('meta[name="Keywords"]').setAttribute('content', to.meta.keywords) : null;

if (to.path) {
window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
};
next();
})


router.afterEach((to, from) => {
if (to.path == '/luckDraw') {
document.documentElement.scrollTop = 0;
document.body.scrollTop = 0;
}
})
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: {
App
},
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js